<div class="wrapper mb-5">
    <div class="row title-container align-items-center" style="padding: 10px;">
        <img src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Notificações</span>
    </div>     
    <div class="nav nav-tabs mt-5" id="nav-tab" role="tablist">
        <ng-container *ngFor="let item of titles">
            <a class="nav-item nav-link" [ngClass]="{'active': item.id == 0}" id="nav-{{item.name}}-tab" data-toggle="tab" href="#nav-{{item.name}}" role="tab" attr.aria-controls="nav-{{item.name}}" aria-selected="false" (click)="tipoNotificacao(item.id)">
                {{item.name}}
            </a>
        </ng-container>
    </div>   
    <div class="form-card mt-0 p-2">
        <div class="row m-0 p-2">
            <div class="col-md-12 text-right">
                <ul class="options-cadastro m-0">
                    <!-- <li>
                        <div (click)="false" class="list-select ml-2 my-1">
                            <button class="list-select-delete" type="button">
                                Apagar filtro
                            </button>
                        </div>
                    </li>
                    <li>
                        <div (click)="false" class="list-select ml-2 my-1">
                            <button class="list-select"  type="button">
                                <span *ngIf="true"><img src="assets/icons/filter.svg" style="height: 15px;"> Aplicar filtro</span>
                                <span *ngIf="false"><img src="assets/icons/filter-purple.svg" style="height: 15px;"> Alterar filtro</span>
                            </button>
                        </div>
                    </li>
                    <li>
                        <div class="list-select-search-input ml-2 my-1">
                            <input class="w-100 ng-untouched ng-pristine
                                ng-valid" placeholder="Pesquise aqui..." type="search" autocomplete="off"/>
                        </div>
                    </li> -->
                    <li>
                        <div class="list-filter-show-item ml-2 my-1">
                            Mostrar:
                            <select (change)="showItemChanged($event.target.value)" class="ng-untouched ng-pristine ng-valid">
                                <option _ selected="" value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row m-0">
            <div [ngClass]="open ? 'col-8' : 'col-12'" class="p-0">
                <div class="table-overflow m-0 p-4 pb-0 scroll">
                    <table class="list-table table table-borderless table-hover m-0">
                        <!-- <thead class="list-table-head">
                            <th></th>
                            <th class="">Titulo</th>
                            <th class="">Categoria</th>
                            <th></th>
                        </thead> -->
                        <tbody class="list-table-row">
                            <tr *ngFor="let item of notificacoes | paginate : { itemsPerPage: showItem,  currentPage: currentPage, totalItems: totalItems }; let i = index;" 
                            class=" list-table-cell small" (click)="selecionarNotificacao(item)">
                                <!-- <td class="clickable" [ngClass]="i == 0 ? 'first-td' : ''"> -->
                                <td class="clickable">
                                    <!-- <div *ngIf="item.unread" class="d-flex justify-content-end">
                                        <div class="readed"></div></div> -->
                                    <div class="row m-0">
                                        <div class="span-container mr-2 col-auto align-items-center">
                                            <img class="bd-placeholder-img flex-shrink-0 me-2 rounded" [src]="'./assets/icons/notificacao/'+ item.type +'.svg'">
                                        </div>
                                        <div class="media-body col-auto">
                                            <div class="row">
                                                <div class="col-6">
                                                    <strong>{{ item.description }}</strong>
                                                </div>
                                                <!-- <div class="col-6">
                                                    <span class="d-flex justify-content-end">Lucas Oliveira</span>
                                                </div> -->
                                            </div>
                                            <div class="row">
                                                <div class="col-9">
                                                    <span class="d-block text-gray-dark" [ngClass]="open ? 'notify-text' : ''">Clique para mais detalhes</span>                                       
                                                </div>
                                                <div class="col-3">
                                                    <span class="d-flex justify-content-end">{{ item.createdAt | date: "dd/MM/yyyy" }}</span>
                                                    <!-- <span *ngIf="!open" class="d-flex justify-content-end text-nowrap">10 de Julho</span>
                                                    <span *ngIf="open" class="d-flex justify-content-end">{{ item.createdAt | date: "dd/MM" }}</span> -->
                                                </div>
                                            </div>
                                            <!-- <div class="row">
                                                <div class="col-auto">
                                                    <span>Clique aqui para ver mais detalhes</span>                                         
                                                </div>
                                            </div> -->
                                                <!-- <div class="d-flex"><span class="justify-content-end">Lucas Oliveira</span></div>
                                                <strong class="d-block text-gray-dark">Resgate de R$100,00 realizado do favorecido João da Silva foi efetuado</strong>
                                                Click aqui para ver mais detalhes -->
                                        </div>
                                    </div>
                                </td>
                                <!-- <td>
                                    <div ngbDropdown class="d-inline-block menu-option">
                                        <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle><img
                                                src="assets/icons/menu.png" /></button>
                                        <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                            <section class="custom-context-menu">
                                                <div ngbDropdownItem (click)="edit(item)"><img src="assets/icons/pencil-purple.png"
                                                        class="mr-2" />Editar</div>
                                                <div ngbDropdownItem (click)="showDelete(deletemodal,item);">
                                                    <img src="assets/icons/garbage-purple.png" class="mr-2" />Excluir
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>   
                <div class="page-custom mt-2">
                    <pagination-controls (pageChange)="carregarNotificacoes($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                </div>
            </div>        
            <div *ngIf="open && notificacaoSelecionada" class="col-4 p-4">
                <h5>{{ notificacaoSelecionada.title }} </h5>
                <p>{{ notificacaoSelecionada.description }}</p>
                <p>Por: {{ getPayloadValue(notificacaoSelecionada.notificationPayload.items,'nomeGestor') }}</p>
                <button *ngIf="showButton" class="list-select" type="button" (click)="clickButton(notificacaoSelecionada)">{{ textButton }}</button>
                <!-- {{ notificacaoSelecionada | json }} -->
            </div>
        </div>
        <!-- <div class="grid-container p-4">
            <div class="grid-item"></div>
                <div class="grid-item">
                    <ul class="list-unstyled m-0">
                    <ng-container  *ngFor="let teste of testes">
                        <li class="media m-2">
                            <div class="span-container mr-2">
                                <img class="bd-placeholder-img flex-shrink-0 me-2 rounded" src="./assets/icons/menu/carteira.svg">
                            </div>
                            <div class="media-body">
                                <p class="small lh-sm m-0">
                                    <strong class="d-block text-gray-dark">Resgatfghdfgdf g dfg dfj ghdfj hfgsdf ghdf u e de R$100,00 realizado do favorecido João da Silva foi efetuado</strong>
                                    Click aqui para ver mais detalhes
                                </p>
                            </div>
                        </li>
                    </ng-container>
                    </ul>
                </div>
            <div class="grid-item"></div>
        </div> -->
    </div>
</div>
